import moment from "moment"
import React, { useEffect, useState } from "react"
import { Col, Row, Table } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import ElmhurstLogo from "../../../Assets/Images/elmhurst-initial-logo.png"
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png"
import noDataImg from "../../../Assets/Images/no-data-img.png";
import Navbar from "../../../Components/Navbar/Navbar"
import Modal from "antd/es/modal/Modal";

import {
  dateFormat,
  numberFormat,
  refreshPage,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import { changePurchaseReturnStatus, getPurchaseReturn } from "../../../Helpers/apiCalls/Purchases/purchaseReturnApi"
import PIModal from "../Pay Suppliers/Components/PIModal"
import Footer from "../../../Components/Footer/Footer"

export default function PrintPurchaseReturn() {
  const id = useParams()
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [purchaseData, setPurchaseData] = useState([])
  const [items, setItems] = useState([])
  const [replacementItems, setReplacementItems] = useState([])

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)
  const [showApproveModal, setShowApproveModal] = useState(false)
  const [showDisapproveModal, setShowDisapproveModal] = useState(false)
  const [preview, setPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState('');
  const [fileList, setFileList] = useState([]);


  async function handlePrintPI() {
    toast.loading("Printing Invoice", { style: toastStyle() })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  async function handleChangeStatus(status) {
    const response = await changePurchaseReturnStatus(id.po_id, status);

    if (response.data) {
      toast.success("Purchase Return " + status + " successfully", {
        style: toastStyle(),
      });
      setTimeout(() => navigate("/purchasereturn"), 1000);

    } else {
      toast.error("Something went wrong", {
        style: toastStyle(),
      });
      // setTimeout(() => refreshPage(), 1000);
    }

  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Item</th>
            <th>Price</th>
            <th>received quantity</th>
            <th>returned qty</th>
            {
              (purchaseData.return_status === "incomplete" || purchaseData.return_status === "completed") && (
                <>
                  <th>balance</th>
                </>
              )
            }
            <th>unit</th>
            <th>Item code</th>
            {/* <th>serial no.</th> */}
            <th>issue</th>
            <th>reason</th>
            {
              (purchaseData.return_status === "incomplete" || purchaseData.return_status === "completed") && (
                <>
                  <th>latest inv date</th>
                  <th>received by</th>
                </>
              )
            }
          </tr>
        </thead>
        <tbody>
          {items &&
            items?.map((item) => {
              return (
                <tr>
                  <td>{item.item_name}</td>
                  <td>{numberFormat(item.price)}</td>
                  <td>{item.received_qty}</td>
                  <td>{item.qty}</td>
                  {
                    (purchaseData.return_status === "incomplete" || purchaseData.return_status === "completed") && (
                      <>
                        <td>{item.remaining_qty}</td>
                      </>
                    )
                  }
                  <td>{item.unit}</td>
                  <td>{item.item_code}</td>
                  {/* <td>{item.serial_no}</td> */}
                  <td>{item.issue}</td>
                  <td>{item.reason}</td>
                  {
                    (purchaseData.return_status === "incomplete" || purchaseData.return_status === "completed") && (
                      <>
                        <td>{dateFormat(item.last_received_date)}</td>
                        <td>{item.last_received_by}</td>
                      </>
                    )
                  }
                </tr>
              )
            })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  async function fetchPurchaseData() {
    const response = await getPurchaseReturn(id.po_id)
    if (response.data) {
      setPurchaseData(response.data.data[0])
      setItems(response.data.data[0].items)
      setFileList(response.data.data[0].attachments)

    }
  }
  useEffect(() => {
    fetchPurchaseData()
  }, [])

  return (
    <div>
      <div className="print-page page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div
        className={`manager-container ${inactive ? "inactive" : "active"}`}
      >
        <br /><br />
        <div className="print-container px-3 py-2" id="printablediv">
          <div className="text-end print-header d-flex flex-column">
            <span>PURCHASE RETURN NO. {purchaseData?.receive_id}</span>
            <span className="text-uppercase">
              {moment(purchaseData.added_on).format("MMMM DD, yyyy")}
            </span>
          </div>
          <div className="d-flex justify-content-center py-1">
            <img alt="logo" src={ElmhurstLogo} className="print-logo-elm" />
          </div>
          <div className="print-top">
              <h5 className="print-shop-header d-flex justify-content-center">497 D Molave Extension, Lahug, Cebu City</h5>
              
          </div>
          <h5 className="print-shop-header d-flex justify-content-center">PURCHASE RETURN</h5>

          {/* content */}
          <div className="print-body mt-5">
            <Row>
              <Col xs={12} lg={6} md={6}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Supplier:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.supplier_name
                      ? purchaseData.supplier_name
                      : purchaseData.vendor_name}
                  </Col>
                </div>

                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Purchase Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(purchaseData.purchase_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Return Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(purchaseData.return_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Receive Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(purchaseData.receive_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Received By:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.receive_by_bodega}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.forwarder_name}
                  </Col>
                </div> */}
              </Col>
              <Col xs={12} lg={6} md={6}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.branch_id_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    DR No.:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.dr_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No.:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.invoice_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Waybill No.:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.waybill_no}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Received By Driver:
                  </Col>
                  <Col xs={7} className="print-data">
                    {purchaseData.receive_by_driver}
                  </Col>
                </div> */}
              </Col>
            </Row>
            {/* <Row>
              <div className="d-flex my-2 align-items-center">
                <Col xs={2} className="print-label">
                  Reason:
                </Col>
                <Col className="print-data">{purchaseData.reason}</Col>
              </div>
            </Row> */}
            <Row>
              <span className="edit-label mt-5 mt-5">Returned Items</span>
            </Row>
            <div className="d-flex justify-content-evenly mb-4">
              <div className="print-table mt-1 mx-2">{renderTable()}</div>
            </div>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={3} className="print-table-footer-label">
                GRAND TOTAL
              </Col>
              <Col xs={3} className="print-table-footer-data text-left">
                PHP{" "}
                {purchaseData.grand_total
                  ? numberFormat(purchaseData.grand_total)
                  : "0.00"}
              </Col>
            </Row>
            <div className="print-body">
              <Row className="mt-5">
                {/* <Col xs={6} className="print-sig justify-content-center d-flex">
                  <img src={purchaseData.receive_by_bodega_signature} className="print-logo" alt=""/>
                </Col> */}
                <Col className="print-sig justify-content-center d-flex">
                  <img src={purchaseData.added_by_name_signature} className="print-logo" />
                </Col>
              </Row>
              <Row className="mt-2 mb-5">
                {/* <Col xs={6} className="print-sig justify-content-center d-flex">
                  <Row className="print-sig justify-content-center gotham">
                    {purchaseData.receive_by_bodega}
                    <div className="margin-underline"></div>
                    Approved by
                  </Row>
                </Col> */}
                <Col className="print-sig justify-content-center d-flex">
                  <Row className="print-sig justify-content-center gotham">
                      {purchaseData.added_by_name}
                    <div className="margin-underline"></div>
                    Prepared by
                  </Row>
                </Col>
              </Row>
            </div>
            {/* <div className="print-signatures mt-5">
              <span className="text-center text-uppercase print-label fw-bold">
                {purchaseData.receive_by_bodega}
              </span>
              <span className="text-center text-uppercase print-label fw-bold">
                {purchaseData.added_by_name}
              </span>
            </div>
            <div className="print-signatories pb-4 mb-4">
              <span>Received by</span>
              <span>Prepared by</span>
            </div> */}
          </div>
        </div>
        
        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">
              FILE ATTACHMENTS
          </Row>
          <Row className="">
              {
                  fileList && fileList.map((attachment) => (
                      <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                          <img src={attachment.file_url}  className="img-preview"/>
                      </Col>
                  ))
              }
              {
                  !fileList || fileList.length === 0 && 
                  <Col xs={1}>
                  <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img src={noDataImg} alt="no data found" className="img-preview"/>
                  </div>
                  </Col>
              }
          </Row>
        </div>

        {/* <Container
          fluid
          className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
        >
          <h5 className="PI-payment-info">PAYMENT INFO</h5>
          <div className="justify-content-center">
            <TablePagination
              tableHeaders={[
                "PAYMENT DATE",
                "TYPE",
                "DETAILS",
                "PAYMENT AMOUNT",
                "AMOUNT APPLIED TO INV",
              ]}
              headerSelector={[
                "payment_date",
                "type",
                "details",
                "amount",
                "amount_applied_to_invoice",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </Container> */}

        {/* footer */}

        {/* <Row className="justify-content-end">
          <Col xs={12} lg={1}>
          </Col>
        </Row> */}

        <div className="d-flex flex-wrap justify-content-end pb-1">
          <button
            className="button-secondary me-1 mb-1"
            onClick={() => navigate("/purchasereturn")}
          >
            Close
          </button>
          {/* <button className="button-primary me-1 mb-1" onClick={handleShowPrintModal}>
            Print
          </button> */}
          {
            purchaseData.status === "for approval" && (
              <>
                <button className="button-tertiary me-1 mb-1" onClick={() => navigate("/purchasereturn/edit/" + id.po_id)}>
                  Edit
                </button>
                <button className="button-primary me-1 mb-1" onClick={() => setShowDisapproveModal(true)}>
                  Disapprove
                </button>
                <button className="button-tertiary" onClick={() => setShowApproveModal(true)}>
                  Approve
                </button>
              </>
            )
          }
        </div>
          {/* {
            purchaseData.status === "for approval" && (
              <>
              <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
                <button className="button-tertiary me-1" onClick={() => navigate("/purchasereturn/edit/" + id.po_id)}>
                  Edit
                </button>
                <button className="button-primary me-1" onClick={() => setShowDisapproveModal(true)}>
                  Disapprove
                </button>
                <button className="button-tertiary" onClick={() => setShowApproveModal(true)}>
                  Approve
                </button>
              </div>
              </>
            )
          } */}
      </div>
      <PIModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        page="purchase return"
        handler={handlePrintPI}
      />
      <PIModal
        show={showApproveModal}
        hide={() => setShowApproveModal(false)}
        type="approve"
        page="purchase return"
        handler={() => handleChangeStatus("approved")}
      />
      <PIModal
        show={showDisapproveModal}
        hide={() => setShowDisapproveModal(false)}
        type="disapprove"
        page="purchase return"
        handler={() => handleChangeStatus("disapproved")}
      />
      <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
          <Row className="justify-content-center">
              <img
                  alt="example"
                  style={{
                  width: '100%',
                  }}
                  src={previewFile}
              />
          </Row>
      </Modal>
      <Footer/>
    </div>
  )
}
